import React from 'react';
import { Link } from 'react-router-dom';
import './HeroSection.css';

export default function HeroSection() {
  const scrollToAbout = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="hero-container" id="home">
      <div className="hero-content">
        <p className="hero-subtitle">Expert Clothing Alterations</p>
        <h1>K-ALTERATIONS</h1>
        <div className="hero-btns">
          <Link to="/services" className="btn-white">
            View Services
          </Link>
        </div>
      </div>
      <div className="scroll-indicator" onClick={scrollToAbout}>
        <i className="fas fa-chevron-down"></i>
      </div>
    </div>
  );
}
